/**
 * In-code feature flags for incremental feature rollout.
 * These are simple boolean constants — flip to enable/disable.
 */

/** When true, day/date and room column headers stick to the top of the viewport on scroll. */
export const STICKY_HEADERS = true;

/** When true, the member-facing /view-booking shows the encrypted "Your booking notes" panel.
 * The endpoint and crypto path stay wired so we can flip this on without code changes. */
export const SHOW_MEMBER_BOOKING_NOTES = false;

/** When true, a member's practice/therapist type (talking / body therapist) is surfaced in the
 * account screen, the admin & PM member screens and the admin member list. The type is still
 * collected at member creation and persisted regardless — this only gates display, so flipping it
 * back on re-exposes the type everywhere with no other code changes. */
export const SHOW_MEMBER_TYPE = false;
